import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FlexLayoutModule } from '@angular/flex-layout';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';
import { TranslateModule } from '@ngx-translate/core';
import { BsDropdownModule } from 'ngx-bootstrap/dropdown';
import { PaginationModule } from 'ngx-bootstrap/pagination';
import { ListboxModule } from 'primeng/listbox';
import { TableModule } from 'primeng/table';
import { FormgenModule } from '../../libraries/formgen/formgen.module';
import { LibrariesModule } from '../../libraries/libraries.module';
import { SharedModule } from '../../libraries/shared.module';
import { FaqCreateComponent } from './create/faq-create.component';
import { FaqFormComponent } from './form/faq-form.component';
import { FaqListComponent } from './list/faq-list.component';
import { FaqRestService } from './faq-rest.service';
import { FaqRoutingModule } from './faq-routing.module';
import { FaqUpdateComponent } from './update/faq-update.component';
import { CKEditorModule } from 'ckeditor4-angular';

export const PROVIDERS = [FaqRestService];

@NgModule({
  imports: [
    FaqRoutingModule,
    BsDropdownModule,
    CommonModule,
    FlexLayoutModule,
    FormgenModule,
    FormsModule,
    ListboxModule,
    LibrariesModule,
    PaginationModule,
    ReactiveFormsModule,
    RouterModule,
    SharedModule,
    TableModule,
    TranslateModule,
    CKEditorModule
  ],
  declarations: [
    FaqCreateComponent,
    FaqFormComponent,
    FaqListComponent,
    FaqUpdateComponent
  ]
})
export class FaqModule {}
